import { render, staticRenderFns } from "./tzzzb.vue?vue&type=template&id=2b335705&scoped=true"
import script from "./tzzzb.vue?vue&type=script&lang=js"
export * from "./tzzzb.vue?vue&type=script&lang=js"
import style0 from "./tzzzb.vue?vue&type=style&index=0&id=2b335705&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b335705",
  null
  
)

export default component.exports